import EyeBrow from "component/commonComponents/eyeBrow/eyeBrow";
import React, { useContext } from "react";
import { ThemeContext } from "styled-components";
import OutageIcon from "../../../assets/icons/outage-generic.svg";
import { OutageCardContainerStyle, OutageCardStyle } from "./outageCard.style";
import { Tooltip } from "@mui/material";
import { handleKeyPress } from "utils/functions";

export interface IOutageCardProps {
  outage: any;
  lastUpdated: string;
  onClickViewDetail: () => void;
  fontSizeBase?: string;
  width?: any;
  outageCardEyeBrow?: boolean;
  eyebrowTitle?: string;
};

const OutageCard = (props: IOutageCardProps) => {
  const { outage, lastUpdated, onClickViewDetail, fontSizeBase, width, outageCardEyeBrow, eyebrowTitle } = props;
  const theme = useContext(ThemeContext);
  
  const clearSelection = () => {
    const selection = window.getSelection();
    if (selection) {
      selection.empty();
    }
  };

  return (
    <OutageCardContainerStyle 
      tabIndex={0}
      widthOutageCard={width ? width :'100%'}
      onKeyDown={(e: any) => handleKeyPress(e, "Enter", onClickViewDetail)}
    >
      <OutageCardStyle
        className="outage-card-container"
        fontSizeBase={fontSizeBase}
        onClick={onClickViewDetail}
        onDragStart={clearSelection}
      >
        <div className="outage-icon">
          {outageCardEyeBrow ?
            <EyeBrow
              color={theme.uptimeColors.newsKnowledgeColors.eyeBrow.majorOutages.color}
              backgroundColor={theme.uptimeColors.newsKnowledgeColors.eyeBrow.majorOutages.background}
              text={eyebrowTitle}
              id={`lbl-outagecard-status`}
            />
            : 
            <img src={OutageIcon} alt="outage-icon" id="img-outagecard-icon" title="Outage Icon" />
          }
          <div className="outage-last-updated" id="lbl-outagecard-last_update">{lastUpdated}</div>
        </div>
        <Tooltip title={outage.name} arrow placement="bottom-start">
          <div className="outage-title select-all-text" id="lbl-outagecard-name" aria-label={outage.name}>{outage.name}</div>
        </Tooltip>
        <div className="outage-content select-all-text" id="lbl-outagecard-content">
          {outage.content}
        </div>
      </OutageCardStyle>
    </OutageCardContainerStyle>
  );
};

export default OutageCard;
